<template>
  <div
    class="bbp-reminder-panel"
    ref="bbpReminderPanel"
    @mouseout.stop="mouseout"
  >
    <BBPReminderPanelHeader
      :isShowForm.sync="isShowForm"
      :counterNotification="reminders.length"
      :row="row"
    />
    <BBPReminderPanelForm
      v-if="isShowForm"
      :isShowForm.sync="isShowForm"
      :defaultBody="defaultBody"
      :row="row"
      :column="column"
    />
    <BBPReminderPanelBody
      v-if="reminders.length || isShowForm"
      :isShowForm="isShowForm"
      @onOpenForm="onOpenForm"
    />
    <BBPPlaceholder
      v-else
      description1="If you want to add reminder –"
      description2="click on the button below"
      button="Add"
      :customStyle="customStyle"
      @onButtonClick="onOpenForm"
    />
  </div>
</template>

<script>
import BBPReminderPanelHeader from
  '@/components/Main/BBPTable/BBPReminder/BBPReminderPanel/BBPReminderPanelHeader/BBPReminderPanelHeader'
import BBPReminderPanelForm from
  '@/components/Main/BBPTable/BBPReminder/BBPReminderPanel/BBPReminderPanelForm/BBPReminderPanelForm'
import BBPReminderPanelBody from
  '@/components/Main/BBPTable/BBPReminder/BBPReminderPanel/BBPReminderPanelBody/BBPReminderPanelBody'
import ReminderApi from '@/api/Reminders/api'
import BBPPlaceholder from '@/components/Main/BBPPlaceholder/BBPPlaceholder'
import { REMINDER_STATUS } from '@/constants/recurReminders'

export default {
  name: 'BBPReminderPanel',
  components: {
    BBPReminderPanelHeader,
    BBPReminderPanelForm,
    BBPReminderPanelBody,
    BBPPlaceholder
  },
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
    column: {
      type: Object,
      default: () => ({})
    },
    remindersList: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    isShowForm: false,
    defaultBody: {},
    customStyle: {
      height: 'calc(100vh - 131px)'
    }
  }),
  computed: {
    reminders: {
      get () {
        return this.$store.getters.reminders
      },
      set (data) {
        this.$store.dispatch('setReminders', data)
      }
    },
    isPickerOpen: {
      get () {
        return this.$store.getters.isPickerOpen
      },
      set (data) {
        this.$store.dispatch('setPickerOpen', data)
      }
    }
  },
  methods: {
    onOpenForm (item) {
      this.defaultBody = item
      this.isShowForm = true
    },
    async getReminder () {
      const { reminderStatus } = this.column
      const isProjectReminder = REMINDER_STATUS.PROJECT === reminderStatus
      const { _id } = this.row
      try {
        const { data } = await ReminderApi.getReminder({project: _id, isProjectReminder})
        this.reminders = data
      } catch (err) {
        console.error(err)
      }
    },
    onClosePanel (e) {
      if (this.isPickerOpen) return
      if (!this.$refs.bbpReminderPanel) return
      if (!this.$refs.bbpReminderPanel.contains(e.target)) {
        this.$store.dispatch('setShowPanel', false)
      }
    },
    mouseout () {
      this.isPickerOpen = false
    }
  },
  watch: {
    isShowForm (newVal) {
      if (!newVal) this.defaultBody = {}
    },
    reminders () {
      this.$emit('update:remindersList', this.reminders)
    }
  },
  beforeMount () {
    this.getReminder()
    setTimeout(() => {
      document.addEventListener('click', this.onClosePanel)
    }, 100)
  },
  beforeDestroy () {
    document.addEventListener('remove', this.onClosePanel)
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../sass/variables";

  .bbp-reminder-panel {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 100;
    width: 404px;
    height: 100vh;
    background: $color-white;
    box-shadow: 0 0 30px rgba($color-black, 0.08);
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPReminder/BBPReminderPanel/BBPReminderPanel.vue